import request from '@/utils/idcardrequest'

export function getReaderInfo() {
  return request({
    url: '/getReaderInfo',
    method: 'get',
    
  })
}

export function readIDCard() {
  return request({
    url: '/readIDCard',
    method: 'get'
  })
}

